import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './styles';

export type AmountBalanceProps = {
  showBalance: boolean;
  isLoadingBalance: boolean;
  isFetchingBalance: boolean;
  balance?: number;
};

function AmountBalance({
  showBalance,
  isLoadingBalance,
  isFetchingBalance,
  balance,
}: AmountBalanceProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'common' });

  if (isLoadingBalance || isFetchingBalance)
      return <S.SkeletonLine width="80px" />;

  if (showBalance) {
    return (
      <S.Text>
        {t('monetary.symbolValue', {
          value: balance || '',
        })}
      </S.Text>
    );
  }

  return <S.Text>{t('monetary.symbol')} ••••••••••••</S.Text>;
}

export default memo(AmountBalance);
